/**
 * 系统菜单
 */
 export default [
    {
      label: '工作台',
      permission: 'home_page_menu',
      icon: 'icon-ic-zhuye',
      shortcut_icon: "bussiness-man",
      path: '/index2',
      id:1,
    },
  ]
  